import InvitationStore from '.';
import { Deactivating, InvitationStatus, Reactivating } from './Types';

interface InvitationOut {
  learning_collection_id: number;
  registration_invitation: {
    invitation_status: InvitationStatus;
  };
}

export const invitationEncoder = (
  store: InvitationStore,
  state: Deactivating | Reactivating,
): InvitationOut => ({
  learning_collection_id: store.invitationsStore.learningCollectionId,
  registration_invitation: {
    invitation_status: state.invitationStatus,
  },
});
